import { Record } from '@gonfalon/immutable-shim/immutableShim';

export class ApprovalCustomWorkflowMetadataStage extends Record<{
  index: number;
  name: string;
}>({
  index: 0,
  name: '',
}) {}
